import React from 'react';
import { Card } from 'react-bootstrap';

export default function SchemeDetails({ scheme, categoryName, typeName, routerURL}) {
  if (!scheme) return null;

  return (
    <Card>
      <Card.Body>
        <Card.Title className="fs-5 fw-bold fw- fst-italic"><u>{scheme.name}</u></Card.Title>
        <Card.Text className="lh-base fs-6 fst-normal">
          { /* <strong>Last NAV:</strong> {scheme.lastActualNav} <br /> */ }
          { /* <strong>Last NAV Date:</strong> {scheme.lastActualNavDate} <br /> */ }
          { /* Add other details as needed {scheme.category} {scheme.type} */ }
          <strong>Category:</strong> {categoryName} <br />
          <strong>Type:</strong>  {typeName} <br />
          <strong>Known Launch Date:</strong> <span className="text-white bg-dark">{scheme.launchDate}</span><br />
          <strong>Selected earliest NAV (for CAGR ...):</strong> {scheme.navBaseValue} <br />
          <strong>Date of Selected earliest NAV:</strong> <span className="text-white bg-dark">{scheme.navBaseValueDate}</span> <br />
        </Card.Text>
        <Card.Text className="lh-md text-primary">
          <strong>Note about Max Predicted Return Trend:</strong> {scheme.maxProbableGainLossNote ? scheme.maxProbableGainLossNote : "N/A"} <br />
        </Card.Text>
        <div className="p-2 mb-2 border rounded bg-light">
          <Card.Text className="lh-base fs-6 fst-normal">
            <strong>% Change in last 7 Days:</strong> {scheme.change7d} <br />
            <strong>% Change in last 30 Days:</strong> {scheme.change30d} <br />
            <strong>% Change in last 90 Days:</strong> {scheme.change90d} <br />
            <strong>% Change in last 270 Days:</strong> {scheme.change270d} <br />
          </Card.Text>
          <Card.Text className="lh-base fs-6 fst-normal">
            <strong>Annualized Returns 3 Year:</strong> {scheme.annualizedReturns3} <br />
            <strong>Annualized Returns 5 Year:</strong> {scheme.annualizedReturns5} <br />
            <strong>CAGR Percentage:</strong> {scheme.cagr_percentage_as_of_last_actual} <br />

            { /* <strong>Probable Gain/Loss:</strong> {scheme.maxProbableGainLoss}, {scheme.meanProbableGainLoss} */ }
            { /* Etc. */}
          </Card.Text>
        </div>
        {/* The boundary container */}
        <div className="p-2 mb-2 border-primary rounded bg-light">
          {
            scheme['Scheme addnl Preds'] == 0 ? 
                        (<Card.Text className="lh-base fs-6 fst-normal">No Additional Predictions</Card.Text>) : (
                                  <Card.Text className="lh-base fs-6 fst-normal"><strong className="lh-md text-primary">Prediction For:</strong> {scheme['Scheme Pred 1: pNAV Date']} <br/>
                                            <strong className="lh-md text-primary">Max pNAV:</strong> {scheme['Scheme Pred 1: pNAV High']}
                                  </Card.Text>
                              )
          }
          {
            scheme['Scheme addnl Preds'] > 1 ? (
                                  <Card.Text><strong className="lh-md text-primary">Prediction For:</strong> {scheme['Scheme Pred 2: pNAV Date']} <br/>
                                            <strong className="lh-md text-primary">Max pNAV:</strong> {scheme['Scheme Pred 2: pNAV High']}
                                  </Card.Text>
                              ) : (<></>)
          }
        </div>
      </Card.Body>
    </Card>
  );
}

